/**
 * Bridge between the OIDC React context and the (React-free) API client.
 *
 * react-oidc-context owns the tokens, but api/client.ts needs the current
 * access token synchronously when it builds a request. The AuthProvider bridge
 * pushes the latest access token here; the API layer reads it. Keeping this in
 * a plain module avoids a React import in config.ts / client.ts and prevents an
 * import cycle.
 */

let currentAccessToken: string | null = null;
let authExpiredHandler: (() => void) | null = null;

export function setAuthToken(token: string | null): void {
  currentAccessToken = token && token.length > 0 ? token : null;
}

export function getAuthToken(): string | null {
  return currentAccessToken;
}

/**
 * Register what happens when the API reports the session is no longer valid
 * (e.g. a 401). In SSO mode the AuthProvider registers a handler that clears
 * the user and starts a fresh sign-in.
 */
export function registerAuthExpiredHandler(handler: (() => void) | null): void {
  authExpiredHandler = handler;
}

export function triggerAuthExpired(): void {
  currentAccessToken = null;
  authExpiredHandler?.();
}
